// extracted by mini-css-extract-plugin
export default {"home":"Home_home__ealXN","search_form":"Home_search_form__Pnrm7","noposts":"Home_noposts__MbBY6"};